import { POS_SHORTCUTS } from './posMockData'
import { useUiLocale } from '@/contexts/UiLocaleContext'

export function PosShortcutBar({ notice = '' }) {
  const { t } = useUiLocale()

  return (
    <footer
      className="pos-v2-shortcut-bar mt-1 shrink-0"
      aria-label="Keyboard shortcuts"
    >
      {notice ? (
        <span className="mb-1 block truncate text-[10px] font-medium text-[#7C3AED] sm:mb-0 sm:mr-2 sm:inline">
          {notice}
        </span>
      ) : null}
      <div className="flex min-w-0 flex-1 flex-wrap items-center justify-start gap-1">
        {POS_SHORTCUTS.map((shortcut) => (
          <span key={shortcut.key} className="pos-v2-shortcut-pill">
            <kbd>{shortcut.key}</kbd>
            <span>{t(shortcut.labelKey)}</span>
          </span>
        ))}
      </div>
    </footer>
  )
}
